// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"283":"620377af","350":"bc3d9c61"}[chunkId] + ".css";
};